document.addEventListener('DOMContentLoaded', function() {
    // Loading anim
    const video = document.getElementById('sihMovie')
    const loadingWp = document.getElementById('sihLoading')
    if(loadingWp){
        function loaderClose(){
            loadingWp.classList.add('__loaded')
            if(video){
                video.firstElementChild.play()
            }
        }
        setTimeout(loaderClose, 1000)
    }
    // Hamburger Nav
    const btnNav = document.getElementById('sihHamburgerBtn')
    const nav = document.getElementById('sihHamburgerTarget')
    const bg = document.getElementById('sihHamburgerOverlay')
    const body = document.getElementsByTagName('body')[0]
    btnNav.addEventListener('click', event => {
        btnNav.classList.toggle('__open')
        nav.classList.toggle('__open')
        bg.classList.toggle('__open')
        body.classList.toggle('__open')
    })
    // Pagetop
    const btnPagetop = document.getElementById('sihPagetopBtn')
    btnPagetop.addEventListener('click', event => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    })
})
